import React, { Component } from 'react';
import { connect } from 'react-redux';
import dropin from 'braintree-web-drop-in';

import actions from '../redux/actions';
import actionTypes from '../redux/actionTypes';
import Heading from '../components/Heading';

class PaymentTest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      instance: null,
      payLoading: false,
      total: 1,
    };
  }

  componentWillMount() {
    this.props.getClientToken();
  }

  componentWillReceiveProps(nextProps) {
    const { paymentStatus } = nextProps;

    if (paymentStatus !== this.props.paymentStatus) {
      if (paymentStatus === actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
        this.setState({ payLoading: false });
      } else if (paymentStatus === actionTypes.PAYMENT_TRANSACTION_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert('error', 'Payment failed. Please try again');
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { clientToken } = this.props;
    const { instance } = this.state;

    if (clientToken && !instance) {
      dropin.create(
        {
          authorization: clientToken,
          container: '#dropin-container',
          translations: {
            chooseAWayToPay: 'Choose a payment option below:',
          },
        },
        (err, instance) => {
          if (!err) {
            this.setState({ instance });
          }
        }
      );
    }
  }

  handlePayment = () => {
    const { instance, total } = this.state;

    // Process purchase and create transaction
    this.props.hideAlert();

    if (instance) {
      this.setState({ payLoading: true }, () => {
        this.props.alert(
          'info',
          'Payment is processing, please do not refresh page.'
        );
      });

      instance.requestPaymentMethod((err, payload) => {
        if (err) {
          console.error(err);
          this.setState({ payLoading: false });
          this.props.alert('error', 'Payment creation failed.');
        } else {
          const data = {
            nonce: payload.nonce,
            amount: total.toString(),
            admin_fee_total: 0,
          };
          this.props.pay(data);
        }
      });
    }
  };

  renderCart() {
    const { total } = this.state;

    return (
      <div className="cart">
        <p>
          <strong>
            Please review your order below. If you leave this session without
            completing this step, your information will not be saved and your
            order will not be processed.
          </strong>
        </p>
        <p>
          <strong>
            Cart Total: <span className="pl4 text-green">${total}</span>
          </strong>
        </p>
      </div>
    );
  }

  render() {
    const { payLoading } = this.state;

    return (
      <div className="complete-pay">
        <Heading text="Review and Checkout" />
        <div className="content">
          <div className="inner">
            {this.renderCart()}
            <div id="dropin-container"></div>

            <div className="payment-action">
              <button
                id="payment-button"
                disabled={payLoading}
                onClick={this.handlePayment}
              >
                {payLoading ? 'Processing...' : 'Pay Now'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  clientToken: state.payment.clientToken,
  paymentStatus: state.payment.status,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  getClientToken: () => {
    dispatch(actions.clientToken());
  },
  pay: (options) => {
    dispatch(actions.pay(options));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentTest);



// WEBPACK FOOTER //
// src/pages/PaymentTest.jsx